<template>
  <page-outline :title="$t('mandate.mode_choice_title') || 'Choix du mode'">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-center mt-4">
          <b-col cols="12" md="6" class="mb-4">
            <div class="mode-card" @click="goToBankSelection">
              <h4 class="mode-card-title">{{ $t('mandate.mode_bank_title') || "Se connecter à mon ancienne banque" }}</h4>
              <p class="mode-card-desc">
                {{ $t('mandate.mode_bank_desc') || "Je m'authentifie auprès de mon ancienne banque et autorise la récupération de mes opérations de prélèvements et de virements" }}
              </p>
              <b-button class="btnFilter_2" @click.stop="goToBankSelection">
                {{ $t('mandate.choose_mode') || 'Choisir ce mode' }}
              </b-button>
            </div>
          </b-col>

          <b-col cols="12" md="6" class="mb-4">
            <div class="mode-card" @click="goToManualForm">
              <h4 class="mode-card-title">{{ $t('mandate.mode_manual_title') || 'Formulaire de saisie' }}</h4>
              <p class="mode-card-desc">
                {{ $t('mandate.mode_manual_desc') || "Je saisie manuellement mes émetteurs et pour chacun d'eux les opérations de prélèvements de virements associées" }}
              </p>
              <b-button class="btnFilter_2" @click.stop="goToManualForm">
                {{ $t('mandate.choose_mode') || 'Choisir ce mode' }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import { loadPage } from '@/helpers/routing'

export default {
  name: 'ModeChoice',
  components: {
    'page-outline': PageOutline
  },
  methods: {
    goToBankSelection () {
      loadPage(this, { url: '/bankselection' })
    },
    goToManualForm () {
      loadPage(this, { url: '/formpage/cdtr' })
      this.$bus.$emit('switch-selected-menu', '/formpage/cdtr')
    }
  }
}
</script>

<style scoped>
.mode-card {
  background: var(--actionTextColorWhite);
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: var(--borderRadius);
  padding: 2rem;
  height: 100%;
  cursor: pointer;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
}

.mode-card:hover {
  border-color: var(--actionButtonColorBlue);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.mode-card-title {
  color: var(--actionButtonColorBlue);
  font-weight: bold;
  margin-bottom: 1rem;
}

.mode-card-desc {
  color: var(--actionTextColorBlack);
  margin-bottom: 1.5rem;
  flex-grow: 1;
}
</style>